import { render, staticRenderFns } from "./EditContractDialog.vue?vue&type=template&id=db8f4808"
import script from "./EditContractDialog.vue?vue&type=script&lang=js"
export * from "./EditContractDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports